const CONNECTED_ACCOUNTS_ENDPOINTS = {
  CONNECTED_ACCOUNTS_HIDE: (brandId: string): string =>
    `/brands/${brandId}/accounts/hide_accounts`,
  CONNECTED_ACCOUNTS_DISPLAY: (brandId: string): string =>
    `/brands/${brandId}/accounts/display_accounts`
};

export default CONNECTED_ACCOUNTS_ENDPOINTS;
